import { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Loader2, ArrowLeft, CheckCircle2 } from 'lucide-react';
import { useAuth, formatApiErrorDetail } from '../context/AuthContext';
import api from '../lib/api';

export default function ProfissionalCadastro() {
  const navigate = useNavigate();
  const { registerProfissional } = useAuth();
  const [form, setForm] = useState({ nome: '', email: '', senha: '', telefone: '', cidade: '', estado: '' });
  const [cidades, setCidades] = useState([]);
  const [erro, setErro] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get('/cidades').then(r => setCidades(r.data)).catch(() => {});
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setErro(''); setLoading(true);
    try {
      await registerProfissional(form);
      navigate('/dashboard');
    } catch (err) {
      setErro(formatApiErrorDetail(err?.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const onCidade = (id) => {
    const c = cidades.find(x => x.id === id);
    if (c) setForm({ ...form, cidade: c.nome, estado: c.uf });
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Link to="/" className="flex items-center gap-2 px-4 py-4 text-sm text-gray-600 hover:text-[#1D9E75]">
        <ArrowLeft size={15} /> Voltar
      </Link>
      <div className="flex-1 flex items-center justify-center px-4 py-6">
        <div className="w-full max-w-md bg-white rounded-2xl shadow-sm p-7">
          <div className="mb-5">
            <h1 className="text-2xl font-bold text-gray-900" style={{ fontFamily: "'Work Sans', sans-serif" }}>Criar conta</h1>
            <p className="text-sm text-gray-500 mt-1">Profissional · 60 dias grátis</p>
          </div>

          <div className="bg-[#E1F5EE] border border-[#1D9E75]/20 rounded-xl px-3 py-2.5 mb-4 flex items-start gap-2">
            <CheckCircle2 size={14} className="text-[#1D9E75] mt-0.5 flex-shrink-0" />
            <p className="text-xs text-[#0F6E56]">
              Você ganha <strong>60 dias grátis</strong> para experimentar. Após esse período, mantenha sua visibilidade por R$ 29,90/ano.
            </p>
          </div>

          <form onSubmit={submit} className="space-y-3">
            <div>
              <label className="block text-xs font-semibold text-gray-700 mb-1">Nome completo *</label>
              <input required value={form.nome} onChange={set('nome')} data-testid="reg-nome-input" className="w-full border border-gray-200 rounded-xl px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#1D9E75]" />
            </div>

            <div>
              <label className="block text-xs font-semibold text-gray-700 mb-1">Email *</label>
              <input type="email" required value={form.email} onChange={set('email')} data-testid="reg-email-input" className="w-full border border-gray-200 rounded-xl px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#1D9E75]" />
            </div>

            <div>
              <label className="block text-xs font-semibold text-gray-700 mb-1">Senha (mín. 6) *</label>
              <input type="password" required minLength={6} value={form.senha} onChange={set('senha')} data-testid="reg-senha-input" className="w-full border border-gray-200 rounded-xl px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#1D9E75]" />
            </div>

            <div>
              <label className="block text-xs font-semibold text-gray-700 mb-1">Telefone (WhatsApp)</label>
              <input value={form.telefone} onChange={set('telefone')} placeholder="(11) 99999-0000" className="w-full border border-gray-200 rounded-xl px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#1D9E75]" />
            </div>

            <div>
              <label className="block text-xs font-semibold text-gray-700 mb-1">Cidade</label>
              <select onChange={(e) => onCidade(e.target.value)} data-testid="reg-cidade-select" className="w-full border border-gray-200 rounded-xl px-3 py-2.5 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-[#1D9E75]">
                <option value="">— Selecione —</option>
                {cidades.map(c => <option key={c.id} value={c.id}>{c.nome} / {c.uf}</option>)}
              </select>
            </div>

            {erro && <div className="bg-red-50 border border-red-200 text-red-700 text-xs rounded-lg px-3 py-2">{erro}</div>}

            <button type="submit" disabled={loading} data-testid="reg-submit-btn"
              className="w-full bg-[#1D9E75] hover:bg-[#178460] text-white font-medium rounded-xl py-2.5 transition-colors disabled:opacity-50 flex items-center justify-center gap-2 mt-2">
              {loading && <Loader2 size={14} className="animate-spin" />} Criar conta grátis
            </button>
          </form>

          <p className="text-center text-xs text-gray-500 mt-6">
            Já tem conta? <Link to="/entrar" className="text-[#1D9E75] font-semibold hover:underline">Entrar</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
